<script lang="ts">

  export let search: string
  export let placeholder: string
  let inputSearch = new URLSearchParams(window.location.search).get('query') || ''

  function onSearch() {
    const url = new URL(window.location.href)
    search = inputSearch
    url.searchParams.set('query', search)
    window.history.pushState(null, '', url.toString())
  }
</script>

<div class="secondary-search">
  <button class="secondary-find-btn search-icon" onclick={onSearch}>
    <i class="icon-p-lupa"></i>
  </button>

  <input class="italic" {placeholder}
         bind:value={inputSearch}
         onkeydown={(e) => e.key === 'Enter' && onSearch()}/>
</div>